export default "__VITE_ASSET__BiMVj$DA__"